/**
 * @fileoverview `@puffin-core/error-handling` — the English (EN) bundle, namespace #57 `errorHandling`.
 * @package @puffin-core/error-handling
 *
 * The package's words live HERE, in the ESM-only `./strings` leaf, and only here. The CommonJS half carries none:
 * the error-to-notification mapper builds its title from a KEY into this catalog, translated by the translator its
 * host hands it (THINKPAD's #57 converge ruling, option (D), 2026-10-23).
 *
 * `notifications.*` moved VERBATIM from pos-web's `errors.notifications.errorTitle.*` and
 * `errors.notifications.errorTitleInComponent` when the mapper did (D1 errorCode unit 4), both locales with their review
 * flags. `notifications.messageUnavailable` is the mapper's own fallback message, which had been an English literal in
 * both halves of this package.
 *
 * @module @puffin-core/error-handling/strings/en
 */

export const ERROR_HANDLING_EN = Object.freeze({
  notifications: Object.freeze({
    errorTitle: Object.freeze({
      system: 'System Error',
      ui: 'UI Error',
      api: 'API Error',
      database: 'Database Error',
      validation: 'Validation Error',
      network: 'Network Error',
      security: 'Security Error',
      businessRule: 'Business Rule Error',
      performance: 'Performance Issue',
      unknown: 'Error',
    }),
    // The whole sentence is a key, never a concatenation: a language with another word order is served by the catalog.
    errorTitleInComponent: '{{title}} in {{component}}',
    messageUnavailable: 'Unknown error occurred',
  }),
  // `formatApiErrorForDisplay`'s slots, moved VERBATIM from both halves of the handler when it stopped composing words
  // (#57). A host shows the server's own sentence when there is one, else `message`, under `title`.
  display: Object.freeze({
    network: Object.freeze({
      title: 'Connection Error',
      message: 'Unable to connect to the server. Please check your internet connection.',
    }),
    timeout: Object.freeze({
      title: 'Request Timeout',
      message: 'The request took too long to complete. Please try again.',
    }),
    authentication: Object.freeze({
      title: 'Authentication Required',
      message: 'Please log in to continue.',
    }),
    forbidden: Object.freeze({
      title: 'Access Denied',
      message: 'You do not have permission to perform this action.',
    }),
    notFound: Object.freeze({
      title: 'Not Found',
      message: 'The requested resource was not found.',
    }),
    validation: Object.freeze({
      title: 'Validation Error',
      message: 'Please check your input and try again.',
    }),
    server: Object.freeze({
      title: 'Server Error',
      message: 'An unexpected server error occurred. Please try again later.',
    }),
    unknown: Object.freeze({
      title: 'Error',
      message: 'An error occurred. Please try again.',
    }),
  }),
});

export default ERROR_HANDLING_EN;
